<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import Dialog from 'next/dialog/Dialog.vue';

const { t } = useI18n();
const store = useStore();
const getters = useStoreGetters();

const attributeKey = ref(null);
const provider = ref({});
const dialogRef = ref(null);
const uiFlags = getters['wgptSamlProviders/getUIFlags'];

const handleDialogConfirm = async () => {
  const { id, config } = provider.value;

  const samlProviderUpdates = {
    id,
    config: {
      ...config,
      attributes: {
        ...config.attributes,
      },
    },
  };
  delete samlProviderUpdates.config.attributes[attributeKey.value];

  try {
    await store.dispatch('wgptSamlProviders/update', samlProviderUpdates);
  } catch (error) {
    const errorMessage =
      error?.message ||
      t('WGPT_SAML.PROVIDERS.EDIT.ATTRIBUTES.DELETE.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  } finally {
    dialogRef.value?.close();
  }
};

const open = (selectedAttributeKey, selectedProvider) => {
  attributeKey.value = selectedAttributeKey;
  provider.value = selectedProvider;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="
      t('WGPT_SAML.PROVIDERS.EDIT.ATTRIBUTES.DELETE.TITLE', {
        attributeKey: attributeKey,
      })
    "
    :description="t('WGPT_SAML.PROVIDERS.EDIT.ATTRIBUTES.DELETE.DESCRIPTION')"
    :confirm-button-label="
      t('WGPT_SAML.PROVIDERS.EDIT.ATTRIBUTES.DELETE.CONFIRM')
    "
    :cancel-button-label="
      t('WGPT_SAML.PROVIDERS.EDIT.ATTRIBUTES.DELETE.CANCEL')
    "
    :is-loading="uiFlags.isUpdating"
    :disable-confirm-button="uiFlags.isUpdating"
    @confirm="handleDialogConfirm"
  />
</template>
